export const devVariables = { apiEndpoint: 'https://dockapp.tielbeke.nl/beheer/api/v1', backendEndpoint: 'https://dockapp.tielbeke.nl/beheer', pusherUrl: "dockapp-wss.tielbeke.nl", pusherKey: "wk6IEonsBWv1Jj63", environmentName: 'Production Environment', ionicEnvName: 'prod' };



// WEBPACK FOOTER //
// ./src/app/environment-variables/development.ts